@if (SiteId && CompanyId) {
  <div class="container-fluid pb-3">
    <div class="row">
      <div class="col">
        <h2>Sites - Edit Site</h2>
      </div>
    </div>
    <div class="row">
      <app-add-edit-site
        [SiteId]="SiteId"
        [CompanyId]="CompanyId"
      ></app-add-edit-site>
    </div>
  </div>
}
